import cutileiApi, { UPLOAD_TIMEOUT } from "./cutileiApi"
import { logApiError } from './apiError'
import AuthService from "./auth"
import download from 'downloadjs'

export default class Document {
  static getFileNameFromHeaders (headers, fallback) {
    const contentDisposition = headers['content-disposition']
    if (!contentDisposition) return fallback

    const filenameStarMatch = contentDisposition.match (/filename\*=UTF-8''([^;]+)/)
    if (filenameStarMatch) return decodeURIComponent (filenameStarMatch[1])

    const filenameMatch = contentDisposition.match (/filename="(.+)"/)
    if (filenameMatch) return filenameMatch[1]

    return fallback
  }

  static async downloadBusinessEarningsPDF ({
    business,
    dateRange,
    sortedEarnings,
    setDownloading
  }) {
    setDownloading (true)
    try {
      const token = AuthService.getToken ()
      const requestConfig = {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      }

      const response = await cutileiApi.post (
        '/documents/businesses/earnings_pdf',
        { business, dateRange, sortedEarnings },
        { responseType: 'blob', timeout: UPLOAD_TIMEOUT, ...requestConfig }
      )

      const { headers, data: document } = response
      const fileName = this.getFileNameFromHeaders (headers, 'Rendimentos e comissões.pdf')

      download (document, fileName)
    } catch (error) {
      logApiError (error)
    } finally {
      setDownloading (false)
    }
  }

  static async downloadProfessionalEarningsPDF ({
    business,
    dateRange,
    typeOption,
    professional,
    sortedEarnings,
    isSimplified,
    setDownloading
  }) {
    setDownloading (true)
    try {
      const token = AuthService.getToken ()
      const showTotalEarnings = AuthService.hasPermission ('financial.total_earnings')
      const requestConfig = {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      }

      const response = await cutileiApi.post (
        '/documents/professionals/earnings_pdf',
        {
          business,
          dateRange,
          typeOption,
          professional,
          sortedEarnings,
          isSimplified,
          showTotalEarnings
        },
        { responseType: 'blob', timeout: UPLOAD_TIMEOUT, ...requestConfig }
      )

      const { headers, data: document } = response
      const fileName = this.getFileNameFromHeaders (headers, 'Rendimentos e comissões.pdf')

      download (document, fileName)
    } catch (error) {
      logApiError (error)
    } finally {
      setDownloading (false)
    }
  }

  static async downloadComissionPaymentPDF ({
    business,
    dateRange,
    professional,
    report,
    setDownloading
  }) {
    setDownloading (true)
    try {
      const token = AuthService.getToken ()
      const requestConfig = {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      }

      const response = await cutileiApi.post (
        '/documents/professionals/comission_payment_pdf',
        { business, dateRange, professional, report },
        { responseType: 'blob', ...requestConfig }
      )

      const { headers, data: document } = response
      const fileName = this.getFileNameFromHeaders (headers, 'Pagamento de comissões.pdf')

      download (document, fileName)
    } catch (error) {
      logApiError (error)
    } finally {
      setDownloading (false)
    }
  }
}
